import * as React from "react";
import { Spinner } from "@components";
import { makeStyles } from "@material-ui/core/styles";

/**
 * Placeholder
 */

type Props = {
  height: number;
  id: string;
};

const useStyles = makeStyles((theme) => ({
  root: {
    transition: theme.transitions.create("height"),
    overflowY: "hidden"
  }
}));

export function Placeholder({ height, id }: Props) {
  const classes = useStyles({});
  const style = { height };

  return (
    <div className={classes.root} style={style} id={id}>
      <Spinner />
    </div>
  );
}
